import React from "react";
import "./PaymentsSettings.css";

// components imports
import UserFormula from "../UserFormula/UserFormula";
import UserMarkup from "../UserMarkup/DefaultMarkup";
import WarehouseFormula from "../WarehouseFormula/WarehouseFormula";
import OneTimeShipperMarkup from "../OneTimeShipperMarkup/OneTimeShipperMarkup";
// apis imports
// library imports

import TabsComponent from "../../../../../Components/Common/TabsComponent";
import { useTranslation } from "react-i18next";

const PaymentsSettings = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [tab, setTab] = React.useState(0);
  const [nestedtab, setNestedTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleNestedTabChange = (event, newValue) => {
    setNestedTab(newValue);
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "5px 5px" }}
    >
      <TabsComponent
        items={[
          {
            label: t("payments.shipper"),
            value: 0,
          },
          { label: t("payments.threePl"), value: 1 },
          {
            label: t("payments.oneTimeShipper"),
            value: 2,
          },
        ]}
        tab={tab}
        handleTabChange={handleTabChange}
        separator
      />

      {tab === 0 && (
        <div className="payments__settings_wrap">
          <div className="payments__settings_card">
            <div className="admnedit__user_modalheading">{t("payments.default")}</div>
            <TabsComponent
              items={[
                {
                  label: t("payments.tier"),
                  value: 0,
                },
                { label: t("payments.markup"), value: 1 },
              ]}
              tab={nestedtab}
              handleTabChange={handleNestedTabChange}
            />
            {nestedtab === 0 && (
              <UserFormula setSnack={setSnack} user={false} />
            )}
            {nestedtab === 1 && <UserMarkup setSnack={setSnack} user={false} />}
          </div>
        </div>
      )}
      {tab === 1 && (
        <div className="payments__settings_wrap">
          <div className="payments__settings_card">
            <WarehouseFormula setSnack={setSnack} user={false} />
          </div>
        </div>
      )}
      {tab === 2 && (
        <div className="payments__settings_wrap">
          <div className="payments__settings_card">
            <div className="admnedit__user_modalheading">{t("payments.default")}</div>
            <OneTimeShipperMarkup setSnack={setSnack} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentsSettings;
